export default __webpack_public_path__ + "static/media/benefit_2@3x.e0db5f0c.png";